import React, { useState } from "react";
import Navbar from "../Component/navbar.jsx";
import Footer from "../Component/footer.jsx";
import "./Contactus.css";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { contactussubmit } from "../reducer/Actions";

import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTwitterSquare,
} from "react-icons/fa";
const Contactus = ({ contactussubmit }) => {
  const [status, setStatus] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
  });

  const handleFocus = (e) => {
    const parent = e.target.parentNode;
    parent.classList.add("focus");
  };

  const handleBlur = (e) => {
    const parent = e.target.parentNode;
    if (e.target.value === "") {
      parent.classList.remove("focus");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangePh = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    // setNumber(onlyDigits);
    setFormData({ ...formData, [e.target.name]: onlyDigits });
  };

  const { name, email, phone, description } = formData;
  // const handlingInput = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission contactussubmit
    contactussubmit(name, email, phone, description);
    setStatus(true);

    // console.log(formData);
  };
  // if (status) {
  //   return <Navigate to={"../"}></Navigate>
  // }
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <div className="container">
        <span className="big-circle"></span>
        <img src="img/shape.png" className="square" alt="" />
        <div className="form">
          <div className="contact-info">
            <h3 className="title">Contact Us</h3>
            <p className="text">
              If you have any questions, comments or requests please email us at
              <span className="text-blue-600"> support@techbeen.co</span>
              <br />
              Alternatively you can submit your query via this form and we will
              get back to you as soon as we can.
            </p>

            <div className="info">
              <div className="from">
                <i className="fas fa-map-marker-alt"></i>
                <h3 className="title">Address: </h3>
                <p className="text">
                  TECHBEEN IT SOLUTIONS PRIVATE LIMITED
                  <br />
                  H-213, Sector 63, NOIDA, Gautam Buddha Nagar, Uttar Pradesh,
                  India 201301
                  <br /> Mumbai Office: Vidya Vihar East, Mumbai-400077
                </p>
              </div>
              <div className="information">
                <i className="fas fa-envelope"></i> &nbsp;&nbsp;
                <p> </p>
              </div>
            </div>

            <div className="social-media">
              <p>Connect with us :</p>
              <div className="social-icons">
                <a href="#">
                  <FaFacebookSquare size="3x" />
                </a>
                <a href="#">
                  <FaInstagramSquare size="2x" />
                </a>
                <a href="#">
                  <FaLinkedin size="2x" />
                </a>
                <a href="#">
                  <FaTwitterSquare size="2x" />
                </a>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <span className="circle one"></span>
            <span className="circle two"></span>

            <form onSubmit={(e) => handleSubmit(e)} autoComplete="off">
              {status ? (
                <Alert severity="success">
                  Thank you for contacting us! Our team will reach out to you
                  soon!
                </Alert>
              ) : (
                <></>
              )}

              <h3 className="title">Contact us</h3>
              <div className="input-container">
                <input
                  type="text"
                  name="name"
                  className="input"
                  value={formData.name}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                />
                <label>User Name</label>
                <span>User Name</span>
              </div>
              <div className="input-container">
                <input
                  type="email"
                  name="email"
                  className="input"
                  value={formData.email}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                />
                <label>Email</label>
                <span>Email</span>
              </div>
              <div className="input-container">
                <input
                  type="tel"
                  name="phone"
                  maxLength="15"
                  className="input"
                  value={formData.phone}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                />
                <label>Phone</label>
                <span>Phone</span>
              </div>
              <div className="input-container textarea">
                <textarea
                  name="description"
                  className="input"
                  value={formData.message}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                ></textarea>
                <label>Message</label>
                <span>Message</span>
              </div>
              <button type="submit" className="w-16 btn">
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default connect(null, { contactussubmit })(Contactus);
